/* eslint-disable jsx-a11y/label-has-for,jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import { forwardRef, useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';

import BaseInput from './StringInput';
import type { StringInputProps } from './StringInput';
import Icon from '../Icon';

const eyeStyles = {
  fontSize: '18px',
  color: 'rgb(120,120,120)',
  cursor: 'pointer',
  display: 'block',
  padding: '4px',
  width: '25px',
  height: '26px',
  zIndex: '10',
};

/** Пропсы поля пароля: {@link StringInputProps} + «глазик» показа/скрытия. */
export interface PasswordInputProps extends StringInputProps {
  /** Отображать элемент управления показом/скрытием пароля. */
  showEye?: boolean;
}

const PasswordInput = forwardRef<HTMLElement, PasswordInputProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const { showEye, ...rest } = props;

  return (
    <BaseInput
      { ...rest }
      type={ showPassword ? 'text' : 'password' }
      shouldComponentUpdate={ () => true }
      ref={ ref }
    >
      { showEye && (
        <InputGroup.Append>
          <Icon
            name={ showPassword ? 'eye-slash' : 'eye' }
            style={ eyeStyles }
            onClick={ () => setShowPassword(!showPassword) }
          />
        </InputGroup.Append>
      ) }
    </BaseInput>
  );
});

export default PasswordInput;
